<template>
 <router-view></router-view>
 <notifications />
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>
